module.exports = __webpack_public_path__ + "img/9.d732ff65.svg";